export function nodeListToArray(nodeList: NodeList): any[] {
    return Array.prototype.slice.call(nodeList);
}